import Vue from 'vue'

import 'normalize.css/normalize.css'
import 'font-awesome/css/font-awesome.min.css';
// 引入element-ui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/theme/element-00C0EF/index.css'
import AFTableColumn from 'af-table-column'

// 兼容IE
import 'babel-polyfill'

// import '@/icons' // icon
import App from './App'
// vuex
import store from './store'
import router from './router'
import './router/permission'
//断点续传 分片上传
import uploader from 'vue-simple-uploader'

import MyPlugin from '@/assets/js/print'

Vue.config.productionTip = false

Vue.use(AFTableColumn)
Vue.use(MyPlugin)
Vue.use(ElementUI)
Vue.use(uploader)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/modules/web/index.js